const getSpotlightData = require('./get_spotlight_data')

module.exports = function getSpotlight(user) {
    // not sure why, but tests are asserting that we return undefined for a null user
    if (! user) return

    // get their spotlight data, merging their data with our spotlight data for that spotlight.type
    const spotlight = getSpotlightData(user.spotlight || {})

    // for pro users, just return their actual spotlight
    const hasFeature = require('./has_feature')
    if (hasFeature(user, 'upgrade')) return spotlight

    // if they have a valid trial spotlight, return that
    const trial_spotlight = getSpotlightData(user.spotlight_trial || {})
    if (trial_spotlight) return trial_spotlight

    // else return their regular spotlight
    return spotlight
}
